import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/service-worker.js')
//       .then((registration) => {
//         console.log('SW registered: ', registration);
//         // Check for updates once per hour — browsers auto-check on navigation anyway
//         setInterval(() => {
//           registration.update();
//         }, 60 * 60 * 1000);
//
//         // Handle service worker updates - update silently in background
//         registration.addEventListener('updatefound', () => {
//           const newWorker = registration.installing;
//
//           newWorker.addEventListener('statechange', () => {
//             if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
//               // New service worker available, update silently in background
//               console.log('New service worker available - updating in background');
//               newWorker.postMessage({ type: 'SKIP_WAITING' });
//             }
//           });
//         });
//       })
//       .catch((registrationError) => {
//         console.log('SW registration failed: ', registrationError);
//       });
//   });
// }

// Unregister any previously active service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}

// Handle install prompt for "Add to Home Screen"
// let deferredPrompt;
// window.addEventListener('beforeinstallprompt', (e) => {
//   e.preventDefault();
//   deferredPrompt = e;
//   console.log('Install prompt available');
// });
//
// window.addEventListener('appinstalled', () => {
//   console.log('PWA was installed');
//   deferredPrompt = null;
// });
//
// window.triggerPWAInstall = () => {
//   if (deferredPrompt) {
//     deferredPrompt.prompt();
//     deferredPrompt.userChoice.then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('User accepted the install prompt');
//       } else {
//         console.log('User dismissed the install prompt');
//       }
//       deferredPrompt = null;
//     });
//   } else {
//     alert('Install prompt not available.');
//   }
// };
